<template>
      <v-content class="bg-content">  
  <v-container class="lead-dashboard" fluid>
    <!-- Search Card -->
          <br />
                    <br />
                              <br />
    <v-card dark class="dashboard-card pa-8 mb-8" outlined>
      <v-row>
        <v-col cols="12">
          <v-card-title class="headline mb-2">🔎 AI Lead Finder</v-card-title>
          <br />
          <v-progress-linear
  v-if="loading"
  :active="loading"
  color="cyan accent-2"
  height="12"
  indeterminate
  class="futuristic-progress"
></v-progress-linear>
          <br />
          <v-select
            :items="leadTypes"
            v-model="leadType"
            label="Type of leads to search for"
            outlined dense class="mb-2"
          />
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="query" label="Search keywords" outlined dense class="mb-2" @keyup.enter="searchLeads" hide-details/>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedState"
                :items="usStates"
                label="State"
                outlined
                dense
                clearable
                class="mb-2"
                hide-details
              />
            </v-col>
            <v-col cols="6" md="2">
              <v-text-field v-model="city" label="City" outlined dense class="mb-2" hide-details/>
            </v-col>
            <v-col cols="6" md="2">
              <v-text-field v-model="zipcode" label="Zipcode" outlined dense class="mb-2" hide-details maxlength="10"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <!-- <v-btn color="primary" :loading="loading" @click="searchLeads" block>
                Search Web <v-icon right>mdi-magnify</v-icon>
              </v-btn> -->
<v-btn
  color="primary"
  :loading="loading"
  @click="searchLeads"
  block
>
  {{ searchId ? 'Search Again (Add More)' : 'Search Web' }}
  <v-icon right>mdi-magnify</v-icon>
</v-btn>


            </v-col>
            <v-col cols="12" sm="8">
              <v-btn color="primary" @click="openLinkedIn" class="mr-2" block>LinkedIn Search</v-btn>
              <v-btn color="info" @click="openYelp" class="mr-2" block>Yelp Search</v-btn>
              <v-btn color="success" @click="openClutch" block>Clutch.co Search</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>




    <!-- Results Table -->
    <v-card v-if="results.length" class="mb-8 dashboard-card" outlined>
      <v-card-title class="headline">Web Results (Google CSE)</v-card-title>
        <v-card-title>
    <v-icon left>mdi-counter</v-icon>
    <strong>Leads Found:</strong> {{ stats.leads }}
    <v-spacer />
    <span class="mx-2"><v-icon small color="light-blue">mdi-email</v-icon> {{ stats.emails }} Emails</span>
    <span class="mx-2"><v-icon small color="amber">mdi-phone</v-icon> {{ stats.phones }} Phones</span>
    <span class="mx-2"><v-icon small color="pink">mdi-map-marker</v-icon> {{ stats.addresses }} Addresses</span>
    <span class="mx-2"><v-icon small color="teal">mdi-account</v-icon> {{ stats.contacts }} Contacts</span>
    <span class="mx-2"><v-icon small color="green">mdi-check-decagram</v-icon> {{ stats.complete }} Complete</span>
  </v-card-title>
      <v-card-text>
        <v-simple-table class="results-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Website</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in results" :key="item.link">
              <td>{{ item.title }}</td>
              <td>
                <a :href="item.link" target="_blank">{{ truncate(item.link, 40) }}</a>
              </td>
              <td>{{ item.snippet }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-btn
          color="cyan"
          class="mt-3"
          @click="analyzeWithAI"
          :loading="analyzing"
          block
        >
          Analyze & Extract Leads <v-icon right>mdi-robot</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
    <v-progress-linear
  v-if="analyzing"
  :active="analyzing"
  color="teal accent-2"
  height="12"
  indeterminate
  class="futuristic-progress"
></v-progress-linear>
<v-progress-linear
  v-if="enriching"
  :active="enriching"
  color="green accent-4"
  height="12"
  indeterminate
  class="futuristic-progress"
></v-progress-linear>
    <!-- Smart AI Lead Grid -->
     <br />
    <v-card v-if="filteredLeads.length" class="mb-8 dashboard-card ai-analysis-card" color="grey darken-3" dark outlined>
      <v-card-title class="headline">
        🏆 Smart AI Leads
        <v-spacer/>
        <!-- <v-btn small color="teal" @click="exportCSV"><v-icon left>mdi-download</v-icon>CSV</v-btn> -->
        <v-btn small class="mr-2" color="blue" @click="exportExcel"><v-icon left>mdi-file-excel</v-icon>Excel</v-btn>
        <v-btn small class="mr-2" color="green" @click="saveLeads"><v-icon left>mdi-content-save</v-icon>Save</v-btn>
        <v-btn small class="mr-2" color="primary2" :loading="enriching" @click="enrichMissingData"><v-icon left>mdi-refresh</v-icon>Enrich Missing Data</v-btn>
      </v-card-title>
      
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="(lead, i) in filteredLeads"
            :key="i"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
<v-card
  class="lead-tile-card mb-4"
  :class="getLeadCardClass(lead)"
  outlined
>
  <div class="lead-status-badge" :class="getLeadStage(lead).stage">
    <v-icon
      v-if="getLeadStage(lead).stage === 'complete'"
      color="green accent-4"
      small
    >mdi-check-decagram</v-icon>
    <v-icon
      v-else-if="getLeadStage(lead).stage === 'working'"
      color="amber accent-3"
      small
    >mdi-timer-sand</v-icon>
    <v-icon
      v-else-if="getLeadStage(lead).stage === 'started'"
      color="light-blue lighten-2"
      small
    >mdi-flash</v-icon>
    <v-icon
      v-else
      color="grey lighten-1"
      small
    >mdi-alert-circle-outline</v-icon>
    <span>{{ getLeadStage(lead).text }}</span>
    <!-- <span class="stat-chip stat-working" v-if="stats.working > 0">
  <v-icon small color="amber accent-3">mdi-timer-sand</v-icon> {{ stats.working }} Working
</span>
<span class="stat-chip stat-started" v-if="stats.started > 0">
  <v-icon small color="light-blue lighten-2">mdi-flash</v-icon> {{ stats.started }} Started
</span> -->

  </div>
  <!-- ...rest of the card as before... -->
<br />
<br />
<br />
              <v-card-title class="lead-tile-title">
                <v-icon left color="light-blue lighten-2" v-if="lead.score >= 80">mdi-star-circle</v-icon>
                <span>{{ lead.name || 'Unknown' }}</span>
                <v-spacer/>
                <v-btn icon color="red" @click="deleteLead(i)" small><v-icon>mdi-delete</v-icon></v-btn>
              </v-card-title>
              <v-card-text class="lead-tile-content">
                <div><v-icon small left color="teal">mdi-account</v-icon> <strong>Contact:</strong> {{ lead.contact || '-' }}</div>
                <div><v-icon small left color="amber">mdi-phone</v-icon> <strong>Phone:</strong> {{ lead.phone || '-' }}</div>
                <div><v-icon small left color="light-blue">mdi-email</v-icon> <strong>Email:</strong> {{ lead.email || '-' }}</div>
                <div><v-icon small left color="pink">mdi-map-marker</v-icon> <strong>Address:</strong> {{ lead.address || '-' }}</div>
                <div><v-icon small left color="cyan">mdi-web</v-icon>
                  <strong>Website:</strong>
                  <a :href="lead.website" target="_blank" style="color:#12fff8;">{{ truncate(lead.website, 26) }}</a>
                </div>
                <div class="mt-2">
                  <v-chip :color="lead.score > 80 ? 'teal accent-3' : lead.score > 60 ? 'amber' : 'grey lighten-2'" dark>
                    Score: <strong>&nbsp;{{ lead.score }}</strong>
                  </v-chip>
                </div>
                <div
                  v-for="([key, val], k) in extraFields(lead)"
                  :key="k"
                  class="extra-field mt-1"
                >
                  <v-icon small left color="green">mdi-information</v-icon>
                  <strong>{{ key | capitalize }}:</strong> {{ val }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackbar" color="success" top>
      Done!
    </v-snackbar>
    <v-card class="dashboard-card mb-5" outlined>
  <v-card-title>
    <v-icon left>mdi-view-list</v-icon> Saved Searches
    <v-spacer/>
    <v-btn small color="green" @click="loadSearches"><v-icon>mdi-refresh</v-icon></v-btn>
  </v-card-title>
  <v-card-text>
    <v-row dense>
      <v-col v-for="s in searches" :key="s.id" cols="12" md="6" lg="4">
        <v-card :class="{'active-search': searchId === s.id}" outlined>
          <v-card-title>
            {{ s.query }} ({{ s.params.leadType }})
            <v-spacer/>
            <v-btn icon small color="blue" @click="selectSearch(s.id)"><v-icon>mdi-magnify</v-icon></v-btn>
            <v-btn icon small color="red" @click="deleteSearch(s.id)"><v-icon>mdi-delete</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            {{ s.params.city }}, {{ s.params.selectedState }}, {{ s.params.zipcode }}<br/>
            Results: {{ (s.results||[]).length }}, Leads: {{ (s.leads||[]).length }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
<!-- Floating HUD Counter -->
<div class="hud-counter futuristic-blur">
  <v-icon color="cyan accent-2" class="mr-2">mdi-counter</v-icon>
  <span class="stat-main">{{ stats.leads }}</span> Leads
  <span class="stat-chip">
    <v-icon small color="light-blue lighten-2">mdi-email</v-icon> {{ stats.emails }}
  </span>
  <span class="stat-chip">
    <v-icon small color="amber accent-2">mdi-phone</v-icon> {{ stats.phones }}
  </span>
  <span class="stat-chip">
    <v-icon small color="pink accent-2">mdi-map-marker</v-icon> {{ stats.addresses }}
  </span>
  <span class="stat-chip">
    <v-icon small color="teal accent-2">mdi-account</v-icon> {{ stats.contacts }}
  </span>
  <span class="stat-chip stat-working" v-if="stats.working > 0">
    <v-icon small color="amber accent-3">mdi-timer-sand</v-icon> {{ stats.working }} Working
  </span>
  <span class="stat-chip stat-started" v-if="stats.started > 0">
    <v-icon small color="light-blue lighten-2">mdi-flash</v-icon> {{ stats.started }} Started
  </span>
  <span class="stat-chip stat-complete" v-if="stats.complete > 0">
    <v-icon small color="green accent-4">mdi-check-decagram</v-icon>
    {{ stats.complete }} Complete
  </span>
</div>

  </v-container>
</v-content>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx"; // <-- install with npm install xlsx

const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia",
  "Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts",
  "Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey",
  "New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island",
  "South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"
];

export default {
  name: "LeadFinder",
  data() {
    return {
 leadTypes: [
  // Artist & Business Representation
  "Music Labels",
  "Artist Management",
  "Business Managers",
  "Booking Agents",
  "Tour Managers",
  "Legal Counsel",
  "Publicists / PR Agencies",

  // Live Event Production
  "Production Companies",
  "Stage Managers",
  "Audio/Visual Providers",
  "Lighting Companies",
  "Sound Engineers",
  "Backline Rental",
  "Touring Crew / Roadies",
  "Set Designers",
  "Rigging Specialists",

  // Venues & Promotion
  "Event Venues",
  "Venue Managers",
  "Promoters",
  "Festival Organizers",
  "Box Office Managers",

  // Marketing & Media
  "Social Media Managers",
  "Digital Marketing Agencies",
  "Radio Stations",
  "Press Contacts",
  "Photographers / Videographers",
  "Street Teams / Fan Clubs",

  // Ticketing & Sales
  "Ticketing Companies",
  "Merchandise Companies",
  "eCommerce Partners",

  // Logistics & Support
  "Travel Agents",
  "Tour Bus Providers",
  "Freight / Gear Logistics",
  "Hotels / Hospitality Partners",
  "Insurance Brokers",
  "Catering Companies",
  "Security Firms",

  // Local & International Partners
  "Local Promoters",
  "Local Crew Chiefs",
  "International Booking Agents",
  "Visa/Immigration Specialists",

  // Technical Services
  "Streaming Partners",
  "IT Support / Network Providers",
  "Pyrotechnics / Special Effects",

  // Additional Stakeholders
  "Sponsors / Brand Partners",
  "Record Distributors",
  "Music Publishers",
  "Songwriters / Composers",
  "Opening Acts / Support Artists",
  "Charity Partners",

  // General Catch-All
  "Other"
],
stats: {
  leads: 0,
  emails: 0,
  phones: 0,
  addresses: 0,
  contacts: 0,
  complete: 0 // how many "fully found" leads
},
      leadType: "",
      query: "",
      city: "",
      zipcode: "",
      selectedState: null,
      usStates: US_STATES,
      searches: [],
      searchId: null,        // current search ID
      results: [],
      leads: [],
      loading: false,
      analyzing: false,
      enriching: false,
      snackbar: false,
      aiResults: null,
      searchOffset: 1,
      resultsPerPage: 10,
      GOOGLE_API_KEY: "AIzaSyBboVjZMYbpCulM_NhAuW5I_e6ZwD5f8qA",
      GOOGLE_CX: "87a5cd3086b3e4db7",
      OPENAI_KEY: "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"
    };
  },
  created() {
    this.loadLeads();
  },
  computed: {
    filteredLeads() {
      return this.leads;
    }
  },
  filters: {
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
      saveSearchMeta() {
    // Save or update search meta in localStorage
    const searches = JSON.parse(localStorage.getItem("ai_searches") || "[]");
    let idx = searches.findIndex(s => s.id === this.searchId);
    const meta = {
      id: this.searchId,
      query: this.query,
      params: {
        leadType: this.leadType,
        city: this.city,
        zipcode: this.zipcode,
        selectedState: this.selectedState
      },
      results: this.results,
      leads: this.leads,
      timestamp: Date.now()
    };
    if (idx >= 0) searches[idx] = meta;
    else searches.push(meta);
    localStorage.setItem("ai_searches", JSON.stringify(searches));
    this.searches = searches;
  },
  loadSearches() {
    this.searches = JSON.parse(localStorage.getItem("ai_searches") || "[]");
  },
selectSearch(id) {
  const search = this.searches.find(s => s.id === id);
  if (search) {
    this.searchId = search.id;
    this.query = search.query;
    this.leadType = search.params.leadType;
    this.city = search.params.city;
    this.zipcode = search.params.zipcode;
    this.selectedState = search.params.selectedState;
    this.results = search.results || [];
    this.leads = search.leads || [];
    this.searchOffset = (this.results.length || 0) + 1;
  }
},
// Add to your methods:
getLeadStage(lead) {
  let filled = 0;
  if (lead.email && lead.email.trim()) filled++;
  if (lead.phone && lead.phone.trim()) filled++;
  if (lead.address && lead.address.trim()) filled++;
  if (lead.contact && lead.contact.trim()) filled++;

  // Return status and color
  if (filled >= 4) return { stage: 'complete', color: 'success', text: 'Complete' };
  if (filled === 3) return { stage: 'working', color: 'warning', text: 'Working' };
  if (filled === 2) return { stage: 'started', color: 'info', text: 'Started' };
  return { stage: 'none', color: 'grey darken-2', text: 'Incomplete' };
},
getLeadCardClass(lead) {
  const stage = this.getLeadStage(lead).stage;
  return {
    'complete-lead': stage === 'complete',
    'working-lead': stage === 'working',
    'started-lead': stage === 'started'
  };
},

  deleteSearch(id) {
    this.searches = this.searches.filter(s => s.id !== id);
    localStorage.setItem("ai_searches", JSON.stringify(this.searches));
    // If current search is deleted, clear form
    if (this.searchId === id) {
      this.searchId = null; this.query = ""; this.results = []; this.leads = [];
    }
  },
    searchQuery() {
      let q = `${this.query} ${this.leadType}`;
      if (this.city) q += ` ${this.city}`;
      if (this.selectedState) q += ` ${this.selectedState}`;
      if (this.zipcode) q += ` ${this.zipcode}`;
      return q.trim();
    },
async searchLeads() {
  this.loading = true;

  // If new search, reset all
  if (!this.searchId) {
    this.results = [];
    this.leads = [];
    this.searchId = Date.now();
    this.searchOffset = 1;
    this.saveSearchMeta();
  }

  try {
    const resp = await axios.get("https://www.googleapis.com/customsearch/v1", {
      params: {
        key: this.GOOGLE_API_KEY,
        cx: this.GOOGLE_CX,
        q: this.searchQuery(),
        num: this.resultsPerPage,
        start: this.searchOffset,
      }
    });

    // Dedupe links already present in results
    const newResults = (resp.data.items || []).filter(
      r => !this.results.find(exist => exist.link === r.link)
    ).map(r => ({
      title: r.title,
      link: r.link,
      snippet: r.snippet,
    }));

    this.results = this.results.concat(newResults);

    // Increment offset for next batch (Google uses 1-based indexing)
    this.searchOffset += this.resultsPerPage;

    // Persist to gallery/search history
    this.saveSearchMeta();
  } catch (e) {
    alert("Google Search failed: " + e.message);
  }
  this.loading = false;
},

isLeadComplete(lead) {
  return (
    lead.email && lead.email.trim() &&
    lead.phone && lead.phone.trim() &&
    lead.address && lead.address.trim() &&
    lead.contact && lead.contact.trim()
  );
},
    // extraFields(lead) {
    //   const fields = {};
    //   if (lead.extra) {
    //     for (const key in lead.extra) {
    //       if (lead.extra[key]) {
    //         fields[key] = lead.extra[key];
    //       }
    //     }
    //   }
    //   return fields;
    // },
    openLinkedIn() {
      window.open(
        `https://www.linkedin.com/search/results/companies/?keywords=${encodeURIComponent(this.searchQuery())}`,
        "_blank"
      );
    },
    openYelp() {
      window.open(
        `https://www.yelp.com/search?find_desc=${encodeURIComponent(this.searchQuery())}`,
        "_blank"
      );
    },
    openClutch() {
      window.open(
        `https://clutch.co/search?search=${encodeURIComponent(this.searchQuery())}`,
        "_blank"
      );
    },
//     async analyzeWithAI() {
//       if (!this.results.length) return;
//       this.analyzing = true;
//       const prompt = `
// You are an expert business lead extractor.
// From the following web search results, extract EVERY possible qualified business lead, even if some fields are missing.
// For each, extract as much as possible: Lead name, Contact name, Phone, Email, Address, Website, and any extra info.
// Score each lead (1-100) for suitability for "${this.leadType}" considering "${this.searchQuery()}".
// Respond with a JSON array of objects (one for EACH potential lead you can find, even partial ones):
// {name, contact, phone, email, address, website, score, [extra]}
// DO NOT LIMIT to a specific number. Include every possible qualified lead you can extract, even if some fields are empty.

// Results:
// ${this.results.map((r, i) =>
//   `Result ${i + 1}:
//   Title: ${r.title}
//   Link: ${r.link}
//   Snippet: ${r.snippet}`).join("\n\n")}
// `;

//       try {
//         const resp = await axios.post(
//           "https://api.openai.com/v1/chat/completions",
//           {
//             model: "gpt-4.1",
//             messages: [
//               { role: "system", content: "You are a smart AI lead extractor and matcher." },
//               { role: "user", content: prompt }
//             ],
//             max_tokens: 8000,
//             temperature: 0.2
//           },
//           { headers: { Authorization: `Bearer ${this.OPENAI_KEY}` } }
//         );
//         let data = resp.data.choices[0].message.content;
//         if (data.startsWith("```json")) data = data.replace(/```json|```/g, "");
//         this.leads = JSON.parse(data);
//         this.saveLeads();
//         this.snackbar = true;
//       } catch (e) {
//         alert("OpenAI extraction failed: " + e.message);
//       }
//       this.analyzing = false;
//     },
async analyzeWithAI() {
  if (!this.results.length) return;
  this.analyzing = true;
  const prompt = `
You are an expert business lead extractor.
From the following web search results, extract EVERY possible qualified business lead, even if some fields are missing.
For each, extract as much as possible: Lead name, Contact name, Phone, Email, Address, Website, and any extra info.
Score each lead (1-100) for suitability for "${this.leadType}" considering "${this.searchQuery()}".
Respond with a JSON array of objects (one for EACH potential lead you can find, even partial ones):
{name, contact, phone, email, address, website, score, [extra]}
DO NOT LIMIT to a specific number. Include every possible qualified lead you can extract, even if some fields are empty.

Results:
${this.results.map((r, i) =>
  `Result ${i + 1}:
  Title: ${r.title}
  Link: ${r.link}
  Snippet: ${r.snippet}`).join("\n\n")}
`;

  try {
    const resp = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4.1",
        messages: [
          { role: "system", content: "You are a smart AI lead extractor and matcher." },
          { role: "user", content: prompt }
        ],
        max_tokens: 8000,
        temperature: 0.2
      },
      { headers: { Authorization: `Bearer ${this.OPENAI_KEY}` } }
    );
    let data = resp.data.choices[0].message.content;
    if (data.startsWith("```json")) data = data.replace(/```json|```/g, "");
    let newLeads = JSON.parse(data);

    // --- DEDUPLICATION LOGIC HERE ---
    // Compare by website (preferably), or name if no website
    const existingWebsites = new Set(
      this.leads.filter(l => l.website).map(l => l.website.trim().toLowerCase())
    );
    const existingNames = new Set(
      this.leads.filter(l => !l.website && l.name).map(l => l.name.trim().toLowerCase())
    );
    newLeads = newLeads.filter(lead => {
      if (lead.website && lead.website.trim()) {
        return !existingWebsites.has(lead.website.trim().toLowerCase());
      } else if (lead.name && lead.name.trim()) {
        return !existingNames.has(lead.name.trim().toLowerCase());
      }
      // If neither website nor name, skip as duplicate
      return false;
    });
    // Now add deduped leads
    this.leads = this.leads.concat(newLeads);
    this.saveLeads();
    this.snackbar = true;
  } catch (e) {
    alert("OpenAI extraction failed: " + e.message);
  }
  this.analyzing = false;
},


async enrichMissingData() {
  this.enriching = true;
  for (let i = 0; i < this.leads.length; i++) {
    const lead = this.leads[i];
    if (
      lead.website &&
      (!lead.email || !lead.phone || !lead.contact || !lead.address)
    ) {
      try {
        // 1. Google CSE search for the website
        const cseResp = await axios.get(
          "https://www.googleapis.com/customsearch/v1",
          {
            params: {
              key: this.GOOGLE_API_KEY,
              cx: this.GOOGLE_CX,
              q: lead.website,
              num: 5,
            },
          }
        );
        const newResults = (cseResp.data.items || []).map((r) => ({
          title: r.title,
          link: r.link,
          snippet: r.snippet,
        }));

        // 2. Try to fetch /contact page HTML as text (CORS permitting)
        let contactPageText = '';
        try {
          const contactUrl = lead.website.replace(/\/$/, "") + "/contact";
          const resp = await axios.get(contactUrl, { responseType: "text" });
          contactPageText = resp.data;
        } catch (err) {
          // Ignore if cannot fetch (CORS)
        }

        // 3. Prompt OpenAI with results + contactPageText
        const prompt = `
Given the following web search results and the /contact page HTML for "${lead.website}", extract ONLY the missing info: Contact name, Phone, Email, Address.
Respond in JSON: {contact, phone, email, address}
---
Web results:
${newResults.map((r, idx) =>
  `Result ${idx + 1}:\nTitle: ${r.title}\nLink: ${r.link}\nSnippet: ${r.snippet}`
).join('\n\n')}
---
Contact page HTML:
${contactPageText.slice(0, 4000)}
        `;
        // 4. Send to OpenAI
        const aiResp = await axios.post(
          "https://api.openai.com/v1/chat/completions",
          {
            model: "gpt-4.1",
            messages: [
              { role: "system", content: "You are a business info extractor and enricher." },
              { role: "user", content: prompt },
            ],
            max_tokens: 2000,
            temperature: 0.2,
          },
          { headers: { Authorization: `Bearer ${this.OPENAI_KEY}` } }
        );
        let newData = aiResp.data.choices[0].message.content.trim();
        if (newData.startsWith("```json")) newData = newData.replace(/```json|```/g, "");
        let enrich = {};
        try { enrich = JSON.parse(newData); } catch (err) { continue; }
        ["contact", "phone", "email", "address"].forEach((f) => {
          if (enrich[f] && !lead[f]) this.$set(this.leads[i], f, enrich[f]);
        });
      } catch (err) {
        // skip errors, continue
      }
      await new Promise((resolve) => setTimeout(resolve, 1200));
    }
  }
  this.saveLeads();
  this.enriching = false;
  this.snackbar = true;
},

    extraFields(lead) {
      const std = ["name", "contact", "phone", "email", "address", "website", "score"];
      return Object.entries(lead).filter(([key]) => !std.includes(key));
    },
    deleteLead(index) {
      this.leads.splice(index, 1);
      this.saveLeads();
    },
computeStats() {
  let stats = {
    leads: this.leads.length,
    emails: 0,
    phones: 0,
    addresses: 0,
    contacts: 0,
    complete: 0,   // all four main fields filled
    working: 0,    // 3 fields filled
    started: 0     // 2 fields filled
  };
  this.leads.forEach(lead => {
    let filled = 0;
    if (lead.email && lead.email.trim()) { stats.emails++; filled++; }
    if (lead.phone && lead.phone.trim()) { stats.phones++; filled++; }
    if (lead.address && lead.address.trim()) { stats.addresses++; filled++; }
    if (lead.contact && lead.contact.trim()) { stats.contacts++; filled++; }
    if (filled === 4) stats.complete++;
    else if (filled === 3) stats.working++;
    else if (filled === 2) stats.started++;
  });
  this.stats = stats;
},

  // After updating leads, always call this
  saveLeads() {
    localStorage.setItem("ai_leads", JSON.stringify(this.leads));
    this.computeStats();
    this.snackbar = true;
  },
  loadLeads() {
    const saved = localStorage.getItem("ai_leads");
    if (saved) this.leads = JSON.parse(saved);
    this.computeStats();
  },
    exportCSV() {
      if (!this.leads.length) return;
      const fields = ["name", "contact", "phone", "email", "address", "website", "score"];
      const csv = [fields.join(",")].concat(
        this.leads.map(lead =>
          fields.map(f => `"${(lead[f] || '').replace(/"/g, '""')}"`).join(",")
        )
      ).join("\r\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "leads.csv";
      a.click();
      URL.revokeObjectURL(url);
    },
    exportExcel() {
      if (!this.leads.length) return;
      const ws = XLSX.utils.json_to_sheet(this.leads);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Leads");
      XLSX.writeFile(wb, "leads.xlsx");
    },
    truncate(text, len = 40) {
      if (!text) return "";
      return text.length > len ? text.substr(0, len - 3) + "..." : text;
    }
  },
};
</script>


<style scoped>
.stat-working { background: linear-gradient(90deg,#ffe784 50%,#ffe90044 100%); color: #6c4c02; }
.stat-started { background: linear-gradient(90deg,#38bcfc 50%,#0fd3ff44 100%); color: #034a78; }

.lead-status-badge {
  position: absolute;
  top: 5%;
  right: 14px;
  display: flex;
  align-items: center;
  font-size: 0.92em;
  font-weight: bold;
  padding: 4px 12px 4px 8px;
  border-radius: 10px;
  background: rgba(18,26,36,0.92);
  box-shadow: 0 0 8px #00ffe999;
  z-index: 10;
  text-shadow: 0 1px 2px #101926cc;
  gap: 7px;
  letter-spacing: 0.04em;
  border: 2px solid transparent;
  transition: background 0.3s, border 0.3s;
}
.lead-status-badge.complete {
  background: linear-gradient(90deg, #14fa9a 0%, #1dc8a7 100%);
  color: #053b1a;
  border-color: #0fae64;
}
.lead-status-badge.working {
  background: linear-gradient(90deg, #ffe784 0%, #f8d447 100%);
  color: #6c4c02;
  border-color: #ffd11f;
}
.lead-status-badge.started {
  background: linear-gradient(90deg, #38bcfc 0%, #18e5ff 100%);
  color: #0a2346;
  border-color: #12eaff;
}
.lead-status-badge.none {
  background: rgba(100,110,120,0.43);
  color: #eee;
  border-color: #636671;
}

.complete-lead {
  border: 3px solid #00ff98 !important;
  box-shadow: 0 0 18px #10ffba99, 0 0 0 2px #00ffe9;
  background: linear-gradient(120deg, #1cd890 60%, #192a3a 90%);
}
.working-lead {
  border: 3px solid #ffd11f !important;
  box-shadow: 0 0 10px #ffe67555, 0 0 0 2px #ffe67533;
  background: linear-gradient(120deg, #fff5a2 24%, #282a2a 80%);
}
.started-lead {
  border: 3px solid #12eaff !important;
  box-shadow: 0 0 12px #12eaff55, 0 0 0 2px #12eaff33;
  background: linear-gradient(120deg, #12eaff 24%, #24254a 80%);
}

.futuristic-progress {
  box-shadow: 0 0 18px #00ffe988, 0 0 2px #12fff888;
  margin-bottom: 0;
  border-radius: 14px;
  background: rgba(8, 32, 62, 0.45) !important;
  z-index: 100;
}

.hud-counter {
  position: fixed;
  top: 140px;
  right: 100px;
  z-index: 888;
  background: rgba(12, 32, 50, 0.93);
  border: 2px solid #00ffe9cc;
  border-radius: 18px;
  padding: 12px 26px 12px 16px;
  box-shadow: 0 0 18px #01e3ff80, 0 4px 22px #00ffe525;
  font-size: 17px;
  font-family: 'Share Tech Mono', 'Orbitron', 'Rajdhani', monospace;
  color: #00ffe9;
  display: flex;
  align-items: center;
  transition: box-shadow 0.25s, background 0.25s;
  backdrop-filter: blur(8px) brightness(1.13);
  gap: 16px;
  pointer-events: none;
  user-select: none;
  animation: hudPulse 2.5s infinite alternate;
}
@keyframes hudPulse {
  0% { box-shadow: 0 0 12px #00ffe988, 0 0 2px #12fff888; }
  100% { box-shadow: 0 0 22px #00ffe9cc, 0 0 12px #00ffe999; }
}
.stat-main {
  font-size: 2.1em;
  font-weight: 700;
  color: #00fff0;
  margin-right: 14px;
  text-shadow: 0 0 12px #00ffe966, 0 0 1px #01e3ff;
}
.stat-chip {
  display: inline-flex;
  align-items: center;
  font-size: 1em;
  background: rgba(22,48,90,0.78);
  border-radius: 12px;
  color: #b5faff;
  padding: 2px 10px 2px 5px;
  margin-left: 9px;
  box-shadow: 0 0 8px #01e3ff2e;
}
.stat-complete {
  background: linear-gradient(90deg, #14fa9a 40%, #00ffe5 100%);
  color: #053b1a !important;
  font-weight: 700;
  text-shadow: 0 0 6px #00ffae77;
}
.futuristic-blur {
  /* Subtle frosted glass effect */
  background: linear-gradient(90deg, #0e2436cc 80%, #00ffe5cc 100%);
  backdrop-filter: blur(8px) brightness(1.11);
}
@media (max-width: 900px) {
  .hud-counter { top: 14px; right: 0; left: 0; width: 98vw; padding: 10px 2vw; border-radius: 12px; justify-content: center;}
  .stat-main { font-size: 1.25em; }
}

.lead-dashboard {
  /* background: linear-gradient(130deg, #192a3a 0%, #1a2636 100%); */
  min-height: 100vh;
  padding-block: 32px 32px 32px 32px;
  width: 92%;
  color: #fff;
}
.dashboard-card {
  background: rgba(15, 30, 60, 0.93);
  border-radius: 20px;
  box-shadow: 0 6px 36px #01e3ff18;
  border: 1.5px solid #00ffe5;
  padding-block: 24px 24px 24px 24px !important;
  margin-block: 16px;
  padding-inline: 16px !important;
  color: #fff;
  font-size: 16px;
  top: -35px;
  position: relative;
}
.dashboard-icon {
  font-size: 4rem;
  filter: drop-shadow(0 0 24px #00eaff99);
  margin-top: 30px;
}
.results-table {
  background: rgba(30,40,70,0.82);
  border-radius: 12px;
  font-size: 15px;
}
.results-table th,
.results-table td {
  color: #12fff8 !important;
  padding: 8px 10px;
}
.ai-analysis-card {
  box-shadow: 0 0 24px #00eaff44;
  border-radius: 16px;
  border: 1.5px solid #12fff8;
}
a {
  color: #00ffe5;
  text-decoration: underline;
  transition: color 0.2s;
}
a:hover {
  color: #fffa86;
}
.lead-tile-card {
  min-height: 330px;
  border-radius: 18px;
  box-shadow: 0 2px 16px #00eaff22;
  background: rgba(30,40,70,0.98);
}
.lead-tile-title {
  font-size: 18px;
  color: #00ffe5;
  font-weight: bold;
  align-items: center;
}
.lead-tile-content {
  font-size: 15px;
  color: #fff;
  line-height: 1.6;
}
.extra-field {
  font-size: 14px;
  color: #aefbcf;
  opacity: 0.88;
}
.complete-lead {
  border: 2px solid #00ff98 !important;
  box-shadow: 0 0 18px #10ffba99, 0 0 0 2px #00ffe9;
  background: linear-gradient(120deg, #1cd890 30%, #192a3a 80%);
  transition: box-shadow 0.3s, border-color 0.3s, background 0.3s;
}

.v-chip {
  font-size: 15px;
}
@media (max-width: 768px) {
  .lead-tile-card { min-height: 280px; }
  .dashboard-card { padding: 12px !important; }
}
</style>
